import { takeEvery, put, call, take } from 'redux-saga/effects'
import store from '../store'
import {
  API_SERVER,
  GET_INDUSTRY_TAX_CARD,
  SHIPBUILDING_INDUSTRY_TAX_CARD
} from '../constants'
import {
  apiManualPost,
  createUploadFileChannel
  // apiManualRequest
} from '../utils/request'
import {
  getIndustryTaxCardSuccess,
  getIndustryTaxCardFailed,
  shipbuildingTaxCardSuccess,
  shipbuildingTaxCardFailed,
  generateIndustryTaxPDFSuccess,
  generateIndustryTaxPDFFailed
} from '../actions'
import { updateFormValues } from '../form'

/**
 * Valtticard saga KAS.335
 *
 * @author Huong Nguyen
 */

function* getIndustryTaxCardSaga({ userData }) {
  try {
    // PI-301 Clear or show Valtti card when searching user email
    const userType = store.getState().client.user.data[5]
    const uuid =
      userType == 2
        ? userData?.uuid ?? store.getState().adminUser.selectedUser.uuid
        : store.getState().client.user.data[2]

    if (!!uuid) {
      // The url to take "last name, firstname, phone number, ssn"
      const basicInfoUrl = `${API_SERVER}/GetUserDetailsTaxID`

      const body = JSON.stringify({
        uuid: uuid
      })

      const basicInfoResult = yield call(apiManualPost, basicInfoUrl, body)
      const basicInfoResultParse = JSON.parse(basicInfoResult.data)

      if (basicInfoResultParse?.tax_number) {
        const formData = {
          ...basicInfoResultParse
        }
        formData.lastname = basicInfoResultParse.last_name
        formData.firstname = basicInfoResultParse.first_name
        formData.phone = basicInfoResultParse.phone_number
        formData.ssn = basicInfoResultParse.ssn
        formData.tax_num = basicInfoResultParse.tax_number
        formData.address = basicInfoResultParse.card_delivery_address
        formData.unit = basicInfoResultParse.apartment_number
        formData.zip_code = basicInfoResultParse.postal_code
        formData.construction =
          basicInfoResultParse.type_valtticard === 'construction' ||
          basicInfoResultParse.type_valtticard === 'construction/shipbuilding'
            ? true
            : false
        formData.shipbuilding =
          basicInfoResultParse.type_valtticard === 'shipbuilding' ||
          basicInfoResultParse.type_valtticard === 'construction/shipbuilding'
            ? true
            : false

        yield put(updateFormValues('taxArea', formData))
      } else {
        yield put(updateFormValues('taxArea', basicInfoResultParse))
      }
      yield put(getIndustryTaxCardSuccess(basicInfoResultParse))
    }
  } catch (error) {
    yield put(getIndustryTaxCardFailed(error))
  }
}

function* shipbuildingTaxCardSaga({ formValues }) {
  try {
    // PI-307 Sending Valtticard from admin user account is failed
    // Because uuid is incorrect
    const login_uuid = store.getState().client.user.data[2]
    const userType = store.getState().client.user.data[5]
    const { adminUser } = store.getState()
    const { selectedUser } = adminUser
    const uuid = userType == 2 ? selectedUser.uuid : login_uuid

    const url = `${API_SERVER}/AddUserIdentityTaxID`
    const file = formValues.inputImage[0]
    const email = store.getState().client.user.data[1]

    const TypeValtticard =
      formValues.construction === true && formValues.shipbuilding === false
        ? 'construction'
        : formValues.construction === false && formValues.shipbuilding === true
        ? 'shipbuilding'
        : formValues.construction === true && formValues.shipbuilding === true
        ? 'construction/shipbuilding'
        : ''

    const body = {
      firstname: formValues.firstname,
      lastname: formValues.lastname,
      ssn: formValues.ssn,
      phone: formValues.phone,
      TaxNumber: formValues.tax_num,
      CardDeliveryAddress: formValues.address,
      ApartmentNumber: formValues?.unit ? formValues?.unit : '',
      PostalCode: formValues.zip_code,
      city: formValues.city,
      TypeValtticard: TypeValtticard
    }

    const channel = yield call(createUploadFileChannel, url, file, body, uuid)

    while (true) {
      const { err, success, data } = yield take(channel)
      if (err) {
        yield put(shipbuildingTaxCardFailed(err))
      }
      if (success) {
        yield put(shipbuildingTaxCardSuccess(data))
      }
      if (data === '"User details stored successfully"') {
        // Calling generate industry tax card PDF and send to asiskaspalvelu@kassvirtanen.fi
        const generatePDFUrl = `${API_SERVER}/GenerateUserTaxDetailsPDF`
        const generatePDFBody = JSON.stringify({
          uuid: uuid,
          firstname: formValues.firstname,
          lastname: formValues.lastname,
          email: userType == 2 ? selectedUser.email : email,
          TypeValtticard: TypeValtticard
        })
        const generatePDFResult = yield call(
          apiManualPost,
          generatePDFUrl,
          generatePDFBody
        )
        if (generatePDFResult.data) {
          yield put(generateIndustryTaxPDFSuccess(generatePDFResult.data))
        } else {
          yield put(generateIndustryTaxPDFFailed())
        }
      }
    }
  } catch (error) {}
}

export function* watchGetIndustryTaxCardSaga() {
  yield takeEvery(GET_INDUSTRY_TAX_CARD, getIndustryTaxCardSaga)
}

export function* watchShipbuildingTaxCardSaga() {
  yield takeEvery(SHIPBUILDING_INDUSTRY_TAX_CARD, shipbuildingTaxCardSaga)
}
